import { CheckYourSearchSpellingText, PleaseContactSalesRepText, ToSeeOrderOnListText } from "constants/text";
import { SaveDraftTemplateModalDetailsInterface } from "./SaveDraft/SaveDraftNoDraftsFilter";

export const NewOrderModalImportCSV = "Import CSV";
export const NewOrderModalDisclaimerText = "Create your item list by providing CSV file(s).";
export const NewOrderModalSupportedFiles = "CSV";
export const NewOrderModalDragFile = "Drag your file(s) here or";
export const NewOrderModalLoadingText = "Hang tight while we read your file...";

export const NewOrderSelectedFiles = "File(s)";

export const NewOrderUnsupportedFile = "Unsupported file! File must be a Quote CSV. Please try again.";

export const NewOrderNoConfigsError =
	"Invalid catalog found in your CSV file. Please make sure that the catalog(s) in your file are supported by Cabinetworks Group and try uploading again. Contact Care if the problem continues.";

export const NewOrderGenericUploadError =
	"Your selected file(s) has issues and cannot be opened. Check that you have the most up-to-date catalog, review and update your file, and try again.";

export const NewOrderContinueButton = "Continue";

export const NewOrderImportSelectionDoesntMatch =
	"Your CSV file has the following catalog error(s) and cannot be opened. Please make sure your 2020 catalog is up-to-date and try uploading again. Contact Care if the problem continues.";
export const GlobalAttributeEmptyError = "Add line item(s) or remove this Global Attribute Group.";

export const LineNumber = "Line #";

export const NewOrderBuildOrderLabel = "Build Order";

export const NewOrderShippingDetailsLabel = "Enter Shipping";
export const ReviewAndPlaceOrder = "Review and Place Order";

export const NewOrderBack = "BACK";

export const NewOrderContinue = "CONTINUE";

export const NewOrderSubmitOrder = "SUBMIT ORDER";
export const SaveAndDownloadNewOrderQuote = "SAVE & DOWNLOAD QUOTE";
export const ConfirmAndSubmit = "YES, ADD AND SUBMIT";
export const CancelAndSubmit = "NO, SUBMIT ANYWAY";
export const TotalPriceText = "Total Price";
export const AddAndExportToAutoCADText = "ADD AND EXPORT TO AUTOCAD";
export const SendQuoteButtonText = "Send Quote";

export const NewOrderPriceEstimate = "Generate price estimate";

export const NewOrderBuildGridFinishColumnHeader = "Finish";

export const NewOrderBuildGridDoorStyleColumnHeader = "Door Style";

export const NewOrderBuildGridQuantityColumnHeader = "Qty";

export const NewOrderViewPriceEstimateTitle = "View Price Estimate";
export const NewOrderViewPriceEstimateListPriceColumnHeader = "List Price";
export const NewOrderViewPriceEstimateExtendedPriceColumnHeader = "Extended Price";
export const EstimatedSubtotalText = "Estimated Subtotal";
export const NewOrderViewPriceEstimatePromotionalPricingText = "Promotional pricing not included.";

export const CustomQuotePricingText = "Custom quotes and promotion pricing not included.";
export const ListAcknowledgementHelperText =
	"Freight Charge, Tariff Surcharge, Added Order Discounts and Estimated Taxes not included.";
export const NetAcknowledgementHelperText =
	"Pricing may vary at time of invoice due to any changes made to order details.";
export const ReferenceQuoteText = "Reference Quote for pricing";

export const RemoveCustomQuoteHeader = "Are you sure you’d like to remove this request?";
export const RemoveCustomQuoteSubheader =
	"The request for this quote and all quotes associated with it will be removed from your list and no longer be active.";
export const RemoveCustomQuoteConfirm = "YES, REMOVE QUOTE";
export const RequestToRemoveQuote = "Request to Remove Quote";

export const NewOrderSaveButton = "Save";

export const NewOrderCancelButton = "Cancel";

export const NewOrderShippingMethod = "Shipping Method";
export const NewOrderSelectAccountError = "Please Select an Account # to Select a Bill To #.";
export const NewOrderSelectBillToError = "Please Select a Bill To #.";

// SAVE DRAFT MODAL
export const SaveDraftText = "Save Draft";
export const SaveTemplateText = "Save Template";
export const SaveAndExitText = "Save and Exit";
export const SaveAsDraftText = "Save as Draft";
export const SaveAsTemplateText = "Save as Template";
export const ComeBackToTemplateText = "Save this order as a template to reuse for future projects.";
export const ComeBackToOrderText = "Come back to this order when you're ready.";
export const ReplacePreviouslySavedDraftText =
	"To overwrite your current draft, save it with the same name. For a new draft, please save with a different name.";
export const ReplacePreviouslySavedTemplateText =
	"To overwrite your current template, save it with the same name. For a new template, please save with a different name.";
export const DraftNamePlaceholder = "Draft Name *";
export const TemplateNamePlaceholder = "Template Name *";
export const NewOrderQuoteNamePlaceholder = "Quote Name *";
export const SaveThisQuoteText = "Save this quote and download the template file.";
export const SubmitQuoteText = "Submit Quote";
export const RemoveDraftConfirm = "YES, REMOVE DRAFT";
export const RemoveDraftModalSubtitle = "This draft will be removed from your draft list and can't be undone.";
export const RemoveDraftModalTitle = "Are you sure you'd like to remove this draft?";
export const RemoveTemplateConfirm = "YES, REMOVE TEMPLATE";
export const RemoveTemplateModalSubtitle = "This template will be removed from your template list and can't be undone.";
export const RemoveTemplateModalTitle = "Are you sure you'd like to remove this template?";

// CANCEL MODAL
export const RequestToCancelHeaderText = "Would you like to request to cancel this order?";
export const HaltProductionText = "Cancelling your order will halt all production processes from continuing.";
export const YouCannotUndoThisActionText = "You cannot undo this action.";
export const CancellationAcknowledgementText = "Your acknowledgement will be updated after successfully processing.";
export const CancellationCheckboxLabel = "Please confirm you have read the above before sending the request.";
export const NoDoNotCancelButton = "No, Do Not Cancel";
export const RequestCancellationButton = "Request Cancellation";
export const CancellationSubmittedBannerTitle = "Your cancellation has been submitted.";
export const CancellationSubmittedBannerDetails =
	"Your acknowledgement will be updated when the cancellation has been processed. If your cancellation cannot be processed, please contact customer Care.";
export const CancellationNotProcessedBannerTitle = "Your cancellation request can not be processed.";
export const CancellationNotProcessedBannerDetails =
	"This order is scheduled for production and can not be cancelled. Please contact Customer Care for further assistance.";
export const HangTightCancellationText = "Hang tight while we send your request...";
export const SuccessfulCancellationText = "We've successfully sent your request!";
export const RequestToCancelText = "Request to Cancel";
export const RequestFailedText = "Request failed to send. Please try again.";

export const SelectAnAddress = "Select a Saved Address";
export const NewOrderDesignerNumberText = "Designer #";
export const NewOrderEnterDesignerNumberText = "Enter Designer # (required)";
export const RequiredText = "(required)";
export const OptionalText = "(optional)";
export const DesignerIsNotHereText = "The Designer # I'm looking for is not here";
export const DesignerConnectionHeaderShippingDetails =
	"You must fill out the Designer Connection form to get paid your SPIFFs if you are manually entering your Designer #.";
export const DesignerConnectionHeaderConfirmation =
	"Don't forget to fill out the Designer Connection form to get paid your SPIFFs!";
export const DesignerConnectionEnsureText = "To ensure you receive your SPIFFs payment, fill out the ";
export const DesignerConnectionFormText = "Designer Connection form.";
export const EnterDesignerHelperText =
	'Designer # must be 6 digits and start with "1". This Designer # will only be submitted with this order. To add it to your Account, please update using the Designer Connection form.';
export const DesignerNumberRequiredText = "Please enter a designer #.";
export const DesignerNumberMatchText = 'Must start with "1" and contain only digits.';
export const CustomDesignerLengthText = (length: number) => `Please enter ${length} digits.`;

export const NewOrdersHeaderSummaryDetailsProductLines = "Product Line(s)";
export const NewOrdersHeaderSummaryDetailsCabinetsCount = "Cab #";
export const NewOrdersHeaderSummaryDetailsAccessoriesCount = "Acc #";
export const NewOrdersHeaderSummaryDetailsCubeCount = "Cube #";
export const NewOrdersHeaderSummaryDetailsOrderType = "Order Type";
export const SelectOrderType = "Select Order Type";
export const OrderDefaultText = "Original (default)";

export const NewOrderReviewPageTitle = "Review and Place Order";
export const ProQuoteReviewPageTitle = "Review and Save Quote";

export const NewOrderOrderDetailsTitle = "Order Details";

export const NewOrderReviewDesignerLabel = "Designer #";

export const NewOrderReviewPOLabel = "PO #";

export const NewOrderReviewJobNameLabel = "Job Name";

export const NewOrderShipToTitle = "Ship To";

export const NewOrderAddressTitle = "Address";

export const NewOrderRequestedDeliveryDate = "Requested Date:";

export const NewOrderDeliveryContact = "Delivery Contact";

export const NewOrderShippingLabelNotes = "Shipping Label Notes";

export const NewOrderUnavailableDataPlaceholderText = "--";

export const NewOrderOrderListHeader = "Order List";

export const NewOrderOrderPurposeTitle = "Order Purpose";
export const BusinessPurposeTitleText = "How will this order be used?*";
export const BusinessPurposeRepairRemodelText = "As part of remodel or repair";
export const BusinessPurposeNewHouseText = "Installed in a new house";
export const BusinessPurposeAptOrDuplexText = "Installed in a new apartment or duplex";
export const BusinessPurposeStockOrderText = "Stored as a Stock Order";
export const BusinessPurposeUnknownText = "Unknown";
export const BusinessPurposeErrorText = "Please make a selection.";

export const NewOrderAccountNumber = "Account #";

export const NewOrderThanksHeader = "Thank you!";
export const NewOrderThanksSubheader =
	"Your order has been submitted. Updates will typically be available in Tandem within 10 minutes. If any further information is needed to process your order, we will reach out directly.";
export const CustomQuoteThanksSubheader =
	"Your order has been submitted. Your order will need to be processed by Customer Care to include your custom quote. If any further information is needed to process your order, we will reach out directly.";
export const NewQuoteOrderThanksSubheader = "Your quote has been submitted.";
export const CustomQuoteHistoryText = "Custom Quote History";
export const NoAvailableQuoteHistory = "Hang tight while we work on your quote!";
export const NoAvailableQuoteHistorySubtitle =
	"Custom Quote files that are ready for you to review and order will be available here.";

export const HistoryViewQuote = "View Quote";
export const HistoryTotalPrice = "Total Price:";

export const AddCustomQuoteText = "Add Custom Quote";
export const DeclineRequest = "Decline Request";

export const NewOrderButton = "Return to Your Orders";
export const NewOrderConfirmationOrderNumber = "Order #";
export const NewOrderConfirmationOrderPending = "Pending";
export const NewOrderOrderDate = "Order Date";
export const NewOrderNewOrderLabel = "New Order";

export const SaveDraftHangTightText = "Hang tight while we save your file....";
export const SaveDraftSuccessfullySavedText = "We've successfully saved your draft!";
export const SaveTemplateSuccessfullySavedText = "We've successfully saved your template!";

export const InputDraftTitleError = "Please enter a draft name to proceed.";
export const InputTemplateTitleError = "Please enter a template name to proceed.";
export const InputQuoteTitleError = "Please enter a quote name to proceed.";
export const DraftErrorTitle = "We're sorry, we couldn't save your draft.";
export const DraftSaveAndExit = "SAVE AND EXIT";
export const DraftExitOrder = "EXIT ORDER";

export const NewOrderRequestedDateLabel = "Requested Date";
export const NewOrderRequestedDateLaterDateButton = "Does your order need to be moved to a later date?";
export const NewOrderRemoveButton = "Remove";
export const NewOrderDraftQuoteDownloadButton = "Download";
export const NewOrderRequestedDateHelperText = "We will schedule the best available date upon review of your request.";
export const NewOrderRemoveItem = "YES, REMOVE ITEM";
export const NewOrderDialogSubtitle = "This item will be removed from your order list and can't be undone.";
export const NewOrderDialogTitle = "Are you sure you'd like to remove this Item?";
export const NewOrderEdit = "Edit";
export const NewOrderOpen = "Open";
export const NewOrderDraftQuoteView = "View";
export const NewOrderSubtitle = "To add line items to your order:";
export const NewOrderEmptyBullet1 = "Import items from a CSV";
export const ImportItems = "IMPORT ITEMS";
export const NewOrderEmptyBullet2 = "Add a Global Attribute Group";
export const SaveDraftTableDisclaimerText =
	"Use a draft when you want to come back to it later to place an order. A draft will no longer be available when an order is submitted or after 6 months of inactivity.";
export const SaveDraftTableSearchText = "Search Drafts by Name";
export const SaveQuoteTableSearchText = "Search Quotes by Name";
export const SaveTemplateTableSearchText = "Search Templates by Name";
export const SaveDraftNoOrdersHeader = "You don't have any saved draft(s)";
export const SaveDraftNoTemplatesHeader = "You don't have any saved template(s)";
export const SaveDraftNoQuotesHeader = "You don't have any saved quote(s)";
export const SaveDraftNoOrdersSubheader = "When you save orders they will appear here.";
export const SaveDraftNoTemplatesSubheader = "When you save templates they will appear here.";
export const SaveDraftNoQuotesSubheader = "When you save or submit quotes they will appear here.";
export const SaveDraft400ErrorHeader = "Uh oh, something went wrong!";
export const SaveDraft400ErrorSubheader = "To see your draft(s), please try:";
export const SaveDraft400ErrorBullet = "Refreshing the page";
export const SaveDraft400ErrorContact = "Please contact Care should the issue continue.";
export const SaveDraftDraftTab = "DRAFTS";
export const SaveDraftTemplateTab = "TEMPLATES";
export const SaveDraftQuoteTab = "QUOTES";
export const SaveDraftTHeadDate = "Date";
export const SaveDraftTHeadDraft = "Name";
export const SaveDraftTHeadAccount = "Account";
export const SaveDraftTHeadDesigner = "Designer";
export const SaveDraftQuoteTHeadUser = "User";
export const SaveDraftTHeadProductLine = "Product Line";
export const SaveDraftQuoteTHeadQuoteNumber = "Quote Number";
export const SaveDraftTHeadOrderType = "Order Type";
export const SaveDraftModalDetails: SaveDraftTemplateModalDetailsInterface = {
	SaveTableDisclaimerText:
		"Use a draft when you want to come back to it later to place an order. A draft will no longer be available when an order is submitted or after 6 months of inactivity.",
	NoSaveFoundHeader: "We’re sorry, we couldn’t find any drafts!",
	NoSaveListSubheader: ToSeeOrderOnListText,
	NoSaveFoundFirstBullet: "Adjusting your filters",
	NoSaveFoundSecondBullet: CheckYourSearchSpellingText,
	NoSaveFoundThirdBullet: "Saving a draft",
	NoSaveListFooter: PleaseContactSalesRepText
};
export const SaveTemplateModalDetails: SaveDraftTemplateModalDetailsInterface = {
	SaveTableDisclaimerText:
		"Use a template when you need to reorder a design multiple times. A template can be reused repeatedly.",
	NoSaveFoundHeader: "We’re sorry, we couldn’t find any templates!",
	NoSaveListSubheader: ToSeeOrderOnListText,
	NoSaveFoundFirstBullet: "Adjusting your filters",
	NoSaveFoundSecondBullet: CheckYourSearchSpellingText,
	NoSaveFoundThirdBullet: "Saving a template",
	NoSaveListFooter: PleaseContactSalesRepText
};
export const SaveQuoteModalDetails: SaveDraftTemplateModalDetailsInterface = {
	NoSaveFoundHeader: "We’re sorry, we couldn’t find any quotes!",
	NoSaveListSubheader: ToSeeOrderOnListText,
	NoSaveFoundFirstBullet: "Adjusting your filters",
	NoSaveFoundSecondBullet: CheckYourSearchSpellingText,
	NoSaveFoundThirdBullet: "Submtting a quote",
	NoSaveListFooter: PleaseContactSalesRepText
};
export const NewOrderUpdateGroup = "UPDATE GLOBAL ATTRIBUTES";
export const NewOrderRemoveGroup = "REMOVE GROUP";
export const NewOrderConfirmRemoveGroup = "YES, REMOVE GROUP";
export const NewOrderRemoveGroupSubtitle =
	"The Global Attribute Group and it's items(s) will be removed from your order list and can't be undone.";
export const NewOrderRemoveGroupTitle = "Are you sure you'd like to remove this Global Attribute Group?";
export const SelectHingeType = "Select Hinge Type";
export const SelectCaseColor = "Select Case";
export const SelectProfile = "Select Profile";
export const SelectProductLine = "Select Product Line";
export const SelectDoorStyle = "Select Door Style";
export const SelectShape = "Select Shape";
export const SelectSpecies = "Select Wood Species";
export const SelectFinish = "Select Finish";
export const CustomColorsDividerText = "Custom Colors";
export const SelectConstruction = "Select Construction";
export const SelectPackaging = "Select Packaging";
export const SelectDistressing = "Select Distressing";
export const SelectAccentColor = "Select Accent Color";
export const SelectAccentApplication = "Select Accent Application";
export const SelectAccountNumber = "Select Account #";
export const SelectBillToNumber = "Select Bill To #";
export const SelectAccountNumberError = "Please select Account #";
export const SelectBillToNumberError = "Please select Bill To #";
export const SelectProductLineError = "Please select a Product Line.";
export const SelectDoorStyleError = "Please select a Door Style.";
export const SelectShapeError = "Please select a Shape.";
export const SelectWoodError = "Please select a Wood Species.";
export const SelectFinishError = "Please select a Finish.";
export const SelectHingeError = "Please select a Hinge Type.";
export const SelectProfileError = "Please select a Cabinet Profile.";
export const SelectCaseColorError = "Please select a Case Color.";
export const SelectConstructionError = "Please select the Construction.";
export const SelectDistressingError = "Please select the Distressing.";
export const SelectAccentColorError = "Please select the Accent Color.";
export const SelectAccentApplicationError = "Please select the Accent Application.";
export const SelectPackagingError = "Please select the Packaging.";
export const AddGlobalAttributesGroupButton = "ADD GLOBAL ATTRIBUTES GROUP";
export const AddGlobalAttributesGroupTitle = "Add Global Attributes Group";
export const UpdateGlobalAttributesGroupTitle = "Update Global Attributes Group";
export const UpdateGlobalAttributesGroupDescription =
	"Updates you make to one attribute may reset the attributes to follow. All attribute fields must be selected before updates can be saved.";
export const AllFieldsRequired = "All fields required.";
export const NAOptionText = "N/A";
export const CustomColorSpeciesNoteText =
	"Note: If the selected species is different than the original sample, the color may appear different.";

export const OrderReviewText = "Order Review";
export const PriceEstimateText = "Price Estimate";
export const OrderConfirmationText = "Order Confirmation";
export const ConfirmationText = "Confirmation";

export const NewOrderProcessError = "We're sorry, we couldn't process your order.";
export const NewOrderNotCorrect =
	"Something doesn't look correct. Before submitting again, please try the following to proceed with your order:";
export const ContactCare = "If you have tried the steps above and the problem continues, please contact Care.";
export const NewOrderGenericError = "Check that your order details and shipping information are correct.";

export const NewOrderBannerAltText =
	"Banner with confetti announcing the launch of a new order processing. The title reads: “We’ve launched a NEW and EASIER ordering process!” The new ordering process is described to include the following enhancements: “Better Validation,” “Multi-Brand Orders,” “Simplified Drafts,” and “Reusable Templates.”";
export const AddOnsBannerAltText =
	'Banner with confetti announcing the launch of a new ordering process for Add-On orders. The banner message reads: “We’ve launched a new and improved ordering process!"';

export const SlowLoadBannerTitleText =
	"Hang tight! We are working on generating your price estimates. This may take a moment.";
export const SlowLoadMessageText =
	"Some product lines may take longer than others. We value your patience. Please do not refresh or exit from this page while we process your order.";

// Landing Page Boxes Constants
export const NewOrderBoxTitle = "New Order";
export const NewOrderBoxText =
	"Placing an order for a new project or display? Upload a CSV or select items to create an order.";
export const AddOnBoxTitle = "Replacement or Add-On";
export const LowesAddOnBoxTitle = "Lowe's XP Orders";
export const AddOnBoxText = "Find the original order to purchase an add-on or request a replacement.";
export const AddOnBoxButtonText = "Find Order";
export const CustomColorBoxTitle = "Custom Color Sample";
export const CustomColorBoxText = "Need a non-standard finish? Let us know the color and we'll send you a door sample.";
export const CustomColorBoxButtonText = "Order Sample";
export const NewQuoteTitleText = "New Quote";
export const StartQuoteButtonText = "Start Quote";
export const NewQuoteBoxText = "Create a new quote and download the template file to send back to the customer.";

export const BuildOrderOptionsTitle = "How would you like to build your order?";

// Fix Catalog Global Attributes
export const FixCatalogGlobalAttributesTitle = "Update Global Attributes";
export const FixCatalogGlobalAttributesDescription =
	"Updates you make to one attribute may reset the attributes to follow. All attribute fields must be selected before updates are saved.";
export const FixCatalogGlobalAttributesSubtitle =
	"We weren’t able to read the global attributes from your CSV file. Please reselect your desired global attributes per catalog.";
export const FixCatalogGlobalAttributesShapeText = "Shape";
export const FixCatalogGlobalAttributesSpeciesText = "Wood Species";
export const FixCatalogGlobalAttributesPackagingText = "Packaging";
export const FixCatalogGlobalAttributesProfileText = "Profile";
export const FixCatalogGlobalAttributesHingeText = "Hinge Type";
export const FixCatalogGlobalAttributesCaseColorText = "Case";
export const FixCatalogGlobalAttributesDistressingText = "Distressing";
export const FixCatalogGlobalAttributesAccentColorText = "Accent Color";
export const FixCatalogGlobalAttributesAccentApplicationText = "Accent Application";
export const FixCatalogGlobalAttributesUpdateGroupsText = "UPDATE GROUPS";
export const FixCatalogGlobalAttributesNextGroupText = "NEXT GROUP";
export const FixCatalogGlobalAttributesLoadingText = "Hang tight while we make those changes....";
